import { render, staticRenderFns } from "./FundingExpense.vue?vue&type=template&id=38ef0355"
import script from "./FundingExpense.vue?vue&type=script&lang=js"
export * from "./FundingExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports